import apiCreateOrder from './functions/apiCreateOrder';
import apiDuplicateOrder from './functions/apiDuplicateOrder';
import apiDeleteOrderItem from './functions/apiDeleteOrderItem';
import apiConfirmOrders from './functions/apiConfirmOrders';
import apiPayOrders from './functions/apiPayOrders';
import apiCreateOrderItem from './functions/apiCreateOrderItem';
import apiOrderViewCollection from './functions/apiOrderViewCollection';

const order = {
  getOrderViewCollection: apiOrderViewCollection,
  createOrder: apiCreateOrder,
  createOrderItem: apiCreateOrderItem,
  duplicateOrder: apiDuplicateOrder,
  deleteOrderItem: apiDeleteOrderItem,
  confirmOrders: apiConfirmOrders,
  payOrders: apiPayOrders
};

export default order;
